export default __webpack_public_path__ + "4a9e06cc444eb66a317a32f12c5bc92e.png";